import { render, staticRenderFns } from "./service-vn-us.vue?vue&type=template&id=4dcbad40&"
import script from "./service-vn-us.vue?vue&type=script&lang=js&"
export * from "./service-vn-us.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports